<template>
    <div class="box-wrap">
        <div class="brian">
            <Brian/>
        </div>
        <div class="box">
	        <template v-if="loaderIsActive">
		        <Loader/>
		        <p>Hvis du ikke bliver automatisk dirigeret videre, klik <a :href="shopLink" target="_blank">her</a></p>
	        </template>
	        <template v-else>
		        <p>Hej med dig.<br/>Skal du være med alle dage?</p>
		        <ul>
			        <li v-for="(date,key) in allDays">
				        <div @click="select(date)" class="date-wrap" :class="{'disabled':datesAvailable.indexOf(date) === -1, 'selected': datesSelected.indexOf(date) !== -1}">
					        <span class="date">{{date}}</span>
					        <span class="month">juli</span>
				        </div>
			        </li>
		        </ul>
		        <p>{{selectedDatesString}}</p>
		        <button v-bind:disabled="total === 0" :class="{'disabled': total === 0}" @click="purchase">Køb entré{{totalVisual}}</button>
		        <div class="cards">
			        <img class="img-responsive" src="@/assets/cards.png" />
		        </div>
	        </template>

        </div>
    </div>
</template>

<script>
	import Brian from "@/assets/login/brian.svg"
	import {removeItemFromArray, setCookie} from "@/helperFunctions";
	import Loader from "@/components/Loader";
	const entreRaw = process.env.VUE_APP_ENTRE_IDS.split(',');
	const entre = {};
	entreRaw.forEach((element) => {
		const parts = element.split('=');
		entre[parts[0]] = parts[1];
	});
	
	export default {
		data(){
			return{
				loaderIsActive: false,
				shopLink: '',
				datesSelected: [],
				entre: entre,
				allDays: [16,17,18]
			}
		},
		mounted(){
			this.datesSelected = this.datesAvailable.slice(0, this.datesAvailable.length)
		},
		methods: {
			select(id){
				if(this.datesAvailable.indexOf(id) !== -1)
				{
					if (this.datesSelected.indexOf(id) === -1)
					{
						this.datesSelected.push(id)
					}
					else
					{
						this.datesSelected = removeItemFromArray(this.datesSelected, id)
					}
					this.datesSelected.sort();
				}
			},
			purchase(){
				if(this.datesSelected.length > 0)
				{
					const selectedString = this.datesSelected.join('');
					if(typeof this.entre[selectedString] !== 'undefined')
					{
						this.loaderIsActive = true;
						const that = this;
						const windowReference = window.open();
						const key = this.$vorbasseSocket.onCommand('one-time-room-created', (result) =>
						{
							that.$vorbasseSocket.dropCommandListener('one-time-room-created',key);
							if(typeof result.result !== 'undefined' && typeof result.data !== 'undefined' && result.result === 200)
							{
								that.$vorbasseSocket.listen(result.data,(response) => {
									that.$vorbasseSocket.stopListening(result.data);
									if(typeof response.code !== 'undefined' && typeof response.data !== 'undefined' && response.code === 200 && typeof response.data.token !== 'undefined')
									{
										if(new Date().getTime() >= 1594893600000)
										{
											setCookie('auth-token', response.data.token, 24 * 365);
											that.$store.commit('vorbasse/reset');
										}
										that.$router.push({name:'koeb-entre-success'})
									}
									else
									{
										that.$store.dispatch('vorbasse/showPrompt',{
											title: 'Køb fejlede',
											prompt: 'Der skete en fejl under købet, prøv igen eller kontakt en medarbejder',
											confirmText: 'Ok - forstået',
											showCancelButton: false
										});
									}
									that.shopLink = '';
									that.loaderIsActive = false;
								});
								that.shopLink = process.env.VUE_APP_SHOP_WOO_CART_ENDPOINT+'?'+that.entre[selectedString]+'=1&socket_key='+result.data;
								windowReference.target = "width=1000,height=700";
								windowReference.location = this.shopLink;
							}
							else
							{
								that.$store.dispatch('vorbasse/showPrompt',{
									title: 'Køb fejlede',
									prompt: 'Der skete en fejl under købet, prøv igen eller kontakt en medarbejder',
									confirmText: 'Ok - forstået',
									showCancelButton: false
								});
							}
						});
						this.$vorbasseSocket.emit('create-one-time-room');
					}
				}
			},
		},
		computed: {
			total(){
				if(this.datesSelected.length === 3){
					return 50;
				}else{
					return this.datesSelected.length * 20
				}
			},
			totalVisual(){
				if(this.total !== 0){
					return " ("+this.total+" kr.)"
				}else{
					return "";
				}
			},
			datesAvailable(){
				let returnArray = []
				let d = new Date()
				let day = d.getDate()
				let month = d.getMonth() + 1
				let currentDateNumber = Number(month + "" + day)
				for(let i=0; i < this.allDays.length; i++){
					let thisDateNumber = Number("7"+this.allDays[i])
					if(thisDateNumber >= currentDateNumber){
						returnArray.push(this.allDays[i])
					}
				}
				return returnArray
			},
			selectedDatesString(){
				if(this.datesSelected.length === 0)
					return 'Du har ikke valgt nogen dage';
				
				let dates = [];
				this.datesSelected.forEach(date => {
					dates.push(date+'.');
				})
				
				return 'Du har valgt d. '+dates.join(' og ');
			}
		},
        components: {
	        Loader,
			Brian
        }
	}
</script>

<style scoped>

</style>
